/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_E1rm_TitleInputs */

const en_us2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max strength`)
};

const pt_br2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima`)
};

const es_419_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza máxima`)
};

const pt_pt2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima`)
};

const fr_fr2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force max`)
};

const de_de2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximalkraft`)
};

const it_it2_exercise_personal_info_e1rm_title = /** @type {(inputs: Exercise_Personal_Info_E1rm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza massima`)
};

/**
* | output |
* | --- |
* | "Max strength" |
*
* @param {Exercise_Personal_Info_E1rm_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_e1rm_title = /** @type {((inputs?: Exercise_Personal_Info_E1rm_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_E1rm_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_e1rm_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_e1rm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_e1rm_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_e1rm_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_e1rm_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_e1rm_title(inputs)
	return en_us2_exercise_personal_info_e1rm_title(inputs)
});
export { exercise_personal_info_e1rm_title as "exercise-personal.info_e1rm_title" }